import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { baseUrl } from "../../utils/baseUrl";
import axios from "axios";
import { CurrentDetailsPayload } from "../../models/IEnums.model";
import { setLocalStorageItem } from "../../utils/localStorage";
import { useDispatch } from "react-redux";
import { setAccountOpeningStep } from "../../redux/accountOpening";
import * as toast from "../../utils/makeToast";
import IdCardSample from "../IdCardSample";
import {
  accountOpeningSteps,
  nextOfKinRelationships,
} from "../../utils/constants";
import OtpDialogModal from "../OtpDialogModal";
import Loader from "../Loader";
import Modal from "../Modal";
import { statesInNigeria } from "../../utils/constants";
import { IUDateUserUpdate } from "../../models/IAccount";
import CustomDropdown from "../CustomDropdown";
import {
  extractValuesFromObj,
  returnInputErrorMessage,
  returnLgaError,
} from "../../utils/helpers";
import apiHooks from "../../customHooks/apis";
import CustomInputField from "../CustomInputField/CustomInputField";
import useAutoUpdateAddress from "../../customHooks/useAutoUpdateAddress";
import { currentDetailsValidationSchema } from "../../utils/validationSchemas";

function UpdateDetailCurrentDialog(props: any) {
  const dispatch = useDispatch();
  const {
    useGetBranchCodes,
    useUserDetails,
    useGetReligions,
    useGetOccupations,
    useGetEmploymentInfo,
    useGetSocialMediaTypes,
  } = apiHooks;
  const { religions, getSelectedReligion } = useGetReligions();
  const { occupations, getSelectedOccupation } = useGetOccupations();
  const { employmentInfo, getSelectedEmployment } = useGetEmploymentInfo();
  const { branches, getSelectedBranch } = useGetBranchCodes();
  const { userDetails, handleUpdateUserDetails } = useUserDetails();
  const { socialMedia, getSocialMedia } = useGetSocialMediaTypes();
  const [updating, setUpdating] = useState(false);
  const [idCardtype, setIdCardType] = useState<any>(1);
  const [ninModalOpen, setNinModalOpen] = useState(false);
  const [otpLoader, setOtpLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showNinModal, setShowNinModal] = useState(false);
  const [showBvnMiddleEmptyModal, setShowBvnMiddleEmptyModal] = useState(false);
  const [showNinMiddleEmptyModal, setShowNinMiddleEmptyModal] = useState(false);
  const [showfirstNameModal, setShowfirstNameModal] = useState(false);
  const [showmiddleNameModal, setShowmiddleNameModal] = useState(false);
  const [showlastNameModal, setShowlastNameModal] = useState(false);
  const [showGenderNameModal, setShowGenderNameModal] = useState(false);
  const [showDobNameModal, setShowDoBNameModal] = useState(false);
  const [genders, SetGenders] = useState<any[]>([
    { name: "Male", value: "M" },
    { name: "Female", value: "F" },
  ]);
  const [lgas, setLgas] = useState([]);

  const goToStep = (step: any) => {
    dispatch(setAccountOpeningStep(step));
  };

  const handleKeyPress = (event) => {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault(); // Prevent input of non-numeric characters
    }
  };

  const formik = useFormik<CurrentDetailsPayload>({
    initialValues: {
      firstName: userDetails?.firstName || "",
      secondName: userDetails?.middleName || "",
      lastName: userDetails?.lastName || "",
      dateOfBirth: userDetails?.dateOfBirth || "",
      phoneNumber: userDetails?.phoneNumber || "",
      emailAddress: userDetails?.email || "",
      houseNumber: "",
      streetName: "",
      areaState: "",
      nearestBustopLandmark: "",
      address: "",
      religion: "",
      nextOfKin: "",
      referralCode: "",
      socialMediaHandle: "",
      gender: "",
      localGovernment: "",
      town: "",
      relationshipOfNextOfKin: "",
      selfEmployementInformation: 0,
      occupation: 0,
      bvn: "",
      socialMediaId: 0,
      termsCondition: false,
      branchOfDomiciliation: 0,
    },
    validationSchema: currentDetailsValidationSchema,
    onSubmit: (values) => {
      updateDetails(values);
    },
  });
  useAutoUpdateAddress<CurrentDetailsPayload>({
    formik,
    fieldNames: [
      "houseNumber",
      "streetName",
      "nearestBustopLandmark",
      "areaState",
    ],
  });

  const updateDetails = (values: CurrentDetailsPayload) => {
    setUpdating(true);
    let updateDetailsPayload: IUDateUserUpdate = {
      religion: `${values.religion}`,
      occupation: +values.occupation,
      selfEmployementInformation: +values.selfEmployementInformation,
      socialMediaId: +values.socialMediaId,
      bvn: userDetails.bvn,
      termsCondition: true,
      firstName: values?.firstName,
      secondName: values?.secondName,
      lastName: values.lastName,
      dateOfBirth: values?.dateOfBirth,
      phoneNumber: values?.phoneNumber,
      emailAddress: values?.emailAddress,
      gender: values?.gender[0].toUpperCase(),
      houseNumber: values?.houseNumber,
      streetName: values?.streetName,
      areaState: values?.areaState,
      nearestBustopLandmark: "",
      address: values?.address,
      nextOfKin: values?.nextOfKin,
      referralCode: values?.referralCode,
      socialMediaHandle: values?.socialMediaHandle,
      town: values?.town,
      localGovernment: "",
      branchOfDomiciliation: values?.branchOfDomiciliation
        ? Number(values?.branchOfDomiciliation)
        : 0,
      relationshipOfNextOfKin: values?.relationshipOfNextOfKin,
    };

    setLocalStorageItem(
      "update-details-page-user-data",
      JSON.stringify(updateDetailsPayload)
    );
    axios
      .post(`${baseUrl}CurrentAccount/CurrentDetails`, updateDetailsPayload)
      .then((response) => {
        const { isSuccess, message } = response?.data || {};
        if (!isSuccess) {
          return toast.errorToast(message);
        }
        toast.successToast(message);
        handleUpdateUserDetails({
          ...formik.values,
          uploadid: response?.data?.obj?.id,
          email: formik.values.emailAddress,
        });

        dispatch(setAccountOpeningStep(accountOpeningSteps.addReference));
        if (formik.values.emailAddress?.length == 0) {
          setOtpLoader(true);
        } else {
        }
      })
      .catch((err) => {
        toast.errorToast(
          err
            ? err?.response?.data?.title
              ? err?.response?.data?.title
              : err?.response?.data?.message
            : "Something went wrong"
        );
      })
      .finally(() => {
        setOtpLoader(false);
        setUpdating(false);
      });
  };

  const getExistingDetails = () => {
    formik.setValues({
      ...formik.initialValues,
      ...extractValuesFromObj(formik.initialValues, userDetails),
      secondName: userDetails?.middleName || "",
    });
  };

  useEffect(() => {
    getExistingDetails();
  }, [userDetails]);

  const handleStateChange = (event) => {
    const selected = event.target.value;
    const state = statesInNigeria.find((state) => state.name === selected);
    if (state) {
      setLgas(state.lgas);
    } else {
      setLgas([]);
    }

    formik.handleChange(event);
  };

  return (
    <div>
      {otpLoader && <Loader />}
      <Modal
        openModal={showModal && showNinModal}
        closeModal={() => setShowModal(false)}
        header="Mobile number MissMatch"
      />
      <Modal
        openModal={showModal && showfirstNameModal}
        closeModal={() => setShowModal(false)}
        header="First name does not match"
        paragraph="Hello Partner, the first name on your BVN does not match the one on your NIN. You may proceed with opening your account; however, a swift (Tier 1) account will be opened for you until the first name mismatch on your BVN/NIN has been resolved. "
      />
      <Modal
        openModal={showModal && showmiddleNameModal}
        closeModal={() => setShowModal(false)}
        header="Middle name mismatch"
        paragraph="The Middle name on your BVN and NIN does not match. Kindly visit any branch of your BVN enrollment bank or the NIMC office to rectify your NIN details."
      />
      <Modal
        openModal={showModal && showlastNameModal}
        closeModal={() => setShowModal(false)}
        header="Last name does not match"
        paragraph="Hi Partner, the Last name on your BVN and NIN does not match. You may proceed with opening your account; however, a swift (Tier 1) account will be opened for you until the last name mismatch on your BVN/NIN has been resolved."
      />
      <Modal
        openModal={showModal && showDobNameModal}
        closeModal={() => setShowModal(false)}
        header="Date of Birth does not match"
        paragraph="Hello Partner, the date of birth in your BVN and NIN records does not match. You may proceed with opening your account; however, a swift (Tier 1) account will be opened for you until the Date of birth mismatch on your BVN/NIN has been resolved. "
      />
      <Modal
        openModal={showModal && showGenderNameModal}
        closeModal={() => setShowModal(false)}
        header="Gender Mismatch/mismatch in gender information "
        paragraph="Hi Partner, the gender details on your BVN and NIN do not match. You may proceed with opening your account; however, a swift (Tier 1) account will be opened for you until the Gender mismatch on your BVN/NIN has been resolved.  "
      />

      <Modal
        openModal={showModal && showBvnMiddleEmptyModal}
        closeModal={() => setShowModal(false)}
        header="Middle name is Empty"
        paragraph="The Middle name on your BVN is empty. Kindly visit any branch of your BVN enrollment bank  to rectify your BVN details "
      />

      <Modal
        openModal={showModal && showNinMiddleEmptyModal}
        closeModal={() => setShowModal(false)}
        header="Middle name is empty"
        paragraph="The Middle name on your NIN is empty. Kindly visit  the NIMC office to rectify your NIN details."
      />
      <form onSubmit={formik.handleSubmit} className="update-details-form-body">
        <div className="card-body">
          <h4 className="card-title text-center pl-3 mt-4">Update details</h4>
          <p className="text-center pl-5 no-wrap">
            Hello{" "}
            <span className="font-weight-bold">
              <b>{userDetails.firstName},</b>{" "}
            </span>
            Welcome to The Alternative Bank
          </p>

          <div className="row">
            <div className="col-sm-12z mt-4 pt-2 sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 sec">
                  <label htmlFor="firstname" className="label_text">
                    Firstname
                  </label>
                  <input
                    name="firstName"
                    value={userDetails.firstName}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Tunde"
                    disabled
                  />
                </div>
                <div className="col-lg-6">
                  <label htmlFor="secondname" className="label_text">
                    Middle Name
                  </label>
                  <input
                    name="secondName"
                    value={userDetails.middleName}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder=""
                    disabled
                  />
                </div>
              </div>
              <div className="row form-row mb-3">
                <div className="col-lg-6">
                  <label htmlFor="lastname" className="label_text">
                    Surname
                  </label>
                  <input
                    name="lastName"
                    value={userDetails.lastName}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Aminah"
                    disabled
                  />
                </div>
                <div className="col-lg-6">
                  <label htmlFor="dateofbirth" className="label_text">
                    Date of birth
                  </label>
                  <input
                    name="dob"
                    value={userDetails.dateOfBirth}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="12-04-1989"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 form-group">
                  <label htmlFor="religion" className="label_text">
                    Gender
                    {/* <span className="text-danger">*</span> */}
                  </label>
                  <select
                    name="gender"
                    onChange={formik.handleChange}
                    value={formik.values.gender}
                    className="form-control border-dark pb-2 pt-3"
                    defaultValue={formik.values.gender}
                    disabled
                  >
                    <option value="">
                      {formik.values.gender || "Select a gender"}
                    </option>
                    {genders.map((gender: any) => {
                      return (
                        <option key={gender.name} value={gender.value}>
                          {gender.name}
                        </option>
                      );
                    })}
                  </select>
                  {formik.touched.gender && formik.errors.gender ? (
                    <small className="text-danger">
                      {formik.errors.gender}
                    </small>
                  ) : null}
                </div>
                <div className="col-lg-6">
                  <CustomInputField
                    // required
                    label="Email address"
                    name="emailAddress"
                    onChange={formik.handleChange}
                    value={formik.values.emailAddress}
                    type="email"
                    className="form-control bg-white border-dark"
                    placeholder=""
                    errorMessage={returnInputErrorMessage<CurrentDetailsPayload>(
                      formik,
                      "emailAddress"
                    )}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row"></div>
          <label
            htmlFor="residentialaddress"
            className="label_text my-2 mt-4 font-weight-bold"
            style={{ display: "block", textAlign: "center" }}
          >
            <b>Residential address</b>
          </label>

          <div className="row">
            <div className="col sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 mr-2">
                  <label htmlFor="housenumber" className="label_text">
                    House number<span className="text-danger">*</span>
                  </label>
                  <input
                    name="houseNumber"
                    onChange={formik.handleChange}
                    value={formik.values.houseNumber}
                    onBlur={formik.handleBlur}
                    type="text"
                    onKeyPress={handleKeyPress}
                    className="form-control bg-white border-dark"
                    placeholder="eg. 12"
                    pattern="[0-9]*" // This pattern allows only numeric characters
                  />
                  {formik.touched.houseNumber && formik.errors.houseNumber ? (
                    <small className="text-danger">
                      {formik.errors.houseNumber}
                    </small>
                  ) : null}
                </div>
                <div className="col-lg-6">
                  <label htmlFor="streetname" className="label_text">
                    Street name<span className="text-danger">*</span>
                  </label>
                  <input
                    name="streetName"
                    onChange={formik.handleChange}
                    value={formik.values.streetName}
                    onBlur={formik.handleBlur}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Bode Thomas"
                  />
                  {formik.touched.streetName && formik.errors.streetName ? (
                    <small className="text-danger">
                      {formik.errors.streetName}
                    </small>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-4">
            <div className="col sec">
              <div className="row form-row mb-3 align-items-end">
                <div className="col-lg-6">
                  <label htmlFor="streetname" className="label_text">
                    Nearest bus-top/landmark
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    name="nearestBustopLandmark"
                    onChange={formik.handleChange}
                    value={formik.values.nearestBustopLandmark}
                    onBlur={formik.handleBlur}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Masha round about"
                  />
                  {formik.touched.nearestBustopLandmark &&
                  formik.errors.nearestBustopLandmark ? (
                    <small className="text-danger">
                      {formik.errors.nearestBustopLandmark}
                    </small>
                  ) : null}
                </div>
                <div className="col-lg-6">
                  <CustomDropdown
                    label="State"
                    required
                    name="areaState"
                    value={formik.values.areaState}
                    onClickOption={handleStateChange}
                    options={statesInNigeria}
                    placeholder="Select state"
                    labelKey="name"
                    valueKey="name"
                    errorMessage={returnInputErrorMessage<
                      typeof formik.initialValues
                    >(formik, "areaState")}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-2">
            <div className="col sec">
              <div className="row form-row mb-3 align-items-end">
                <div className="col-lg-6">
                  <CustomInputField
                    required
                    label="Town"
                    name="town"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.town}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Enter your town"
                    errorMessage={returnInputErrorMessage<CurrentDetailsPayload>(
                      formik,
                      "town"
                    )}
                  />
                </div>
                <div className="col-lg-6 mr-2">
                  <CustomDropdown
                    required
                    label="Local Government"
                    name="localGovernment"
                    onClickOption={formik.handleChange}
                    value={formik.values.localGovernment}
                    placeholder="Select LGA"
                    options={lgas}
                    errorMessage={returnLgaError({
                      stateError: returnInputErrorMessage<
                        typeof formik.initialValues
                      >(formik, "localGovernment"),
                      lgaError: returnInputErrorMessage<
                        typeof formik.initialValues
                      >(formik, "areaState"),
                    })}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="form-group mb-4">
            <label htmlFor="address" className="label_text">
              Enter Full Address<span className="text-danger">*</span>
            </label>
            <input
              name="address"
              onChange={formik.handleChange}
              value={formik.values.address}
              className="form-control sec border-dark"
              type="text"
              id="address"
              placeholder="No 12 Bode Thomas Masha round about Lagos"
              readOnly
            />
            {formik.touched.address && formik.errors.address ? (
              <small className="text-danger">{formik.errors.address}</small>
            ) : null}
          </div>
          <label
            htmlFor="residentialaddress"
            className="label_text my-2 mt-4 font-weight-bold"
            style={{ display: "block", textAlign: "center" }}
          >
            <b>Other Information</b>
          </label>
          <div className="form-group mb-4">
            <label htmlFor="nextofkin" className="label_text">
              Name of next of kin<span className="text-danger">*</span>
            </label>
            <input
              name="nextOfKin"
              onChange={formik.handleChange}
              value={formik.values.nextOfKin}
              onBlur={formik.handleBlur}
              className="form-control border-dark"
              type="text"
              id="name"
              placeholder="Enter name of next of kin"
            />
            {formik.touched.nextOfKin && formik.errors.nextOfKin ? (
              <small className="text-danger">{formik.errors.nextOfKin}</small>
            ) : null}
          </div>
          <div className="row d-flex mt-3 mb-4">
            <div className="col-lg-6 form-group">
              <CustomDropdown
                required
                label="Relationship to Next Of Kin"
                name="relationshipOfNextOfKin"
                onClickOption={formik.handleChange}
                value={formik.values.relationshipOfNextOfKin}
                options={nextOfKinRelationships}
                errorMessage={returnInputErrorMessage<CurrentDetailsPayload>(
                  formik,
                  "relationshipOfNextOfKin"
                )}
                formik={formik}
              />
            </div>

            <div className="col-lg-6 form-group">
              <CustomDropdown
                required
                label="Religion"
                name="religion"
                onClickOption={formik.handleChange}
                value={getSelectedReligion(Number(formik.values.religion))}
                options={religions}
                placeholder="Select religion"
                errorMessage={returnInputErrorMessage<CurrentDetailsPayload>(
                  formik,
                  "religion"
                )}
                labelKey="religion"
                valueKey="id"
                formik={formik}
              />
            </div>
          </div>

          <div className=" row d-flex form-group mb-4">
            <div className="col-lg-6">
              <CustomDropdown
                required
                label="Self employment information"
                name="selfEmployementInformation"
                onClickOption={formik.handleChange}
                value={getSelectedEmployment(
                  Number(formik.values.selfEmployementInformation)
                )}
                options={employmentInfo}
                placeholder="Select employment information"
                errorMessage={returnInputErrorMessage<CurrentDetailsPayload>(
                  formik,
                  "selfEmployementInformation"
                )}
                labelKey="name"
                valueKey="id"
                formik={formik}
              />
            </div>
            <div className="col-lg-6 mr-0">
              <CustomDropdown
                required
                label="Occupation"
                name="occupation"
                onClickOption={formik.handleChange}
                value={getSelectedOccupation(Number(formik.values.occupation))}
                options={occupations}
                placeholder="Select occupation"
                errorMessage={returnInputErrorMessage<CurrentDetailsPayload>(
                  formik,
                  "occupation"
                )}
                labelKey="name"
                valueKey="id"
                formik={formik}
              />
            </div>
          </div>

          <div className="row mb-4">
            <div className="col sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 mr-2">
                  <CustomDropdown
                    label="Social media type"
                    name="socialMediaId"
                    onClickOption={formik.handleChange}
                    value={getSocialMedia(formik.values.socialMediaId)}
                    options={socialMedia}
                    placeholder="--Choose one--"
                    errorMessage={returnInputErrorMessage<CurrentDetailsPayload>(
                      formik,
                      "socialMediaId"
                    )}
                    labelKey="name"
                    valueKey="id"
                    formik={formik}
                  />
                </div>
                <div className="col-lg-6">
                  <label htmlFor="socialMediaHandle" className="label_text">
                    Enter social media link/handle
                  </label>
                  <input
                    name="socialMediaHandle"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.socialMediaHandle}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="@john_doe"
                  />
                  {formik.touched.socialMediaHandle &&
                  formik.errors.socialMediaHandle ? (
                    <small className="text-danger">
                      {formik.errors.socialMediaHandle}
                    </small>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-2 align-items-end">
            <div className="col-lg-6 form-group">
              <CustomDropdown
                required
                label="Branch of Domiciliation"
                name="branchOfDomiciliation"
                onClickOption={formik.handleChange}
                value={getSelectedBranch(
                  formik.values.branchOfDomiciliation.toString()
                )}
                placeholder="Select"
                options={branches}
                labelKey="branch"
                valueKey="brancH_CODE"
                errorMessage={returnInputErrorMessage<
                  typeof formik.initialValues
                >(formik, "branchOfDomiciliation")}
                formik={formik}
              />
            </div>
            <div className="form-group col-lg-6">
              <label htmlFor="refferalcode" className="label_text">
                DAO/Referral code(optional)
              </label>
              <input
                name="referralCode"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referralCode}
                className="form-control border-dark"
                type="text"
                id="name"
                placeholder="Enter referral code"
              />
            </div>
          </div>
          <label
            htmlFor="residentialaddress"
            className="label_text my-2 mt-4 font-weight-bold"
            style={{ display: "block", textAlign: "center" }}
          ></label>

          <div className="form-group">
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane show fade active"
                id="pills-int"
                role="tabpanel"
                aria-labelledby="pills-int-tab"
              >
                <div className="row mb-4">
                  <div className="col-md-3"></div>
                </div>
              </div>
            </div>
          </div>

          <OtpDialogModal
            openModal={ninModalOpen}
            closeModal={() => setNinModalOpen(false)}
            routeTo="document-upload"
          />

          <div className="d-flex justify-content-end mt-4">
            <button
              onClick={() => {
                goToStep("bvn-validation");
              }}
              style={{ marginRight: "10px" }}
              className="btn btn-outline-gold mr-3 btn-filled-white"
            >
              Previous
            </button>
            {updating ? (
              <div className="spinner-border text-gold" role="status">
                <span className="sr-only"></span>
              </div>
            ) : (
              <button
                onClick={() => {}}
                disabled={!formik?.isValid || !formik?.dirty}
                type="submit"
                className="btn btn-filled-red"
              >
                Proceed
              </button>
            )}
          </div>
        </div>
      </form>

      {/*  */}
      <div
        className="modal fade"
        id="idCardSampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <IdCardSample idCardType={idCardtype} />
            </div>
          </div>
        </div>
      </div>
      {/*  */}
    </div>
  );
}

export default UpdateDetailCurrentDialog;
